import { BlockSelectionData, WorkoutGroupedData } from '../types';

export function groupSelectionData(
  selections: readonly BlockSelectionData[],
): WorkoutGroupedData[] {
  const dataByWorkout = new Map<string, WorkoutGroupedData['data']>();

  for (const selection of selections) {
    const data = dataByWorkout.get(selection.workoutId);

    if (selection.type === 'Set') {
      if (data) {
        data.push({
          type: 'Set',
          exercise: selection.exercise,
          set: selection.set,
          metrics: selection.metrics,
          disabled: selection.disabled,
        });
      } else {
        dataByWorkout.set(selection.workoutId, [
          {
            type: 'Set',
            exercise: selection.exercise,
            set: selection.set,
            metrics: selection.metrics,
            disabled: selection.disabled,
          },
        ]);
      }
    }
  }
  return Array.from(dataByWorkout.entries()).map(([workoutId, data]) => ({
    workoutId,
    data,
  }));
}
